import Request from 'src/utils/request'

/**
 * 保存数据大屏
 * @returns
 */
export function saveScreenApi (data) {
  return Request({
    url: '/panel',
    method: 'post',
    data,
  })
}
